import { __awaiter } from '../node_modules/tslib/tslib.es6.js';
import { composeHeaderParameter } from '../utils/paramHelper.js';

class AssistantClient {
    constructor(endpoint, initData) {
        this.endpoint = endpoint;
        this.initData = initData;
    }
    getCookie() {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = composeHeaderParameter(this.initData);
            try {
                yield fetch(`${this.endpoint}cookie`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: headers
                });
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    fetchInitSessionInfo(trainingId) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = composeHeaderParameter(this.initData);
            try {
                const response = yield fetch(`${this.endpoint}${encodeURIComponent(trainingId)}/session`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: headers
                });
                const data = yield response.json();
                return data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    submitFeedback(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = composeHeaderParameter(this.initData);
            try {
                yield fetch(`${this.endpoint}submitFeedback`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: headers,
                    body: JSON.stringify(payload),
                });
            }
            catch (e) {
                console.error(e);
            }
        });
    }
}

export { AssistantClient };
